// Centralized matching-mode UI metadata so badges, table headers, and tooltips
// stay consistent everywhere when a new mode is added.

export const MODES = ['llm', 'local-llm', 'vector', 'hybrid', 'vector-llm', 'hybrid-os', 'hybrid-os-judge'];

const META = {
  'llm':              { badge: 'llm-mode',              label: 'LLM',         short: 'LLM',   tableHeader: 'Sem',   tooltip: 'LLM semantic score' },
  'local-llm':        { badge: 'local-llm-mode',        label: 'Local LLM',   short: 'L-LLM', tableHeader: 'Sem',   tooltip: 'Self-deployed Gemma (Vertex) semantic score' },
  'vector':           { badge: 'vector-mode',           label: 'Vector',      short: 'Vec',   tableHeader: 'Vec',   tooltip: 'Vector similarity' },
  'hybrid':           { badge: 'hybrid-mode',           label: 'Hybrid',      short: 'Hyb',   tableHeader: 'Hyb',   tooltip: 'Hybrid RRF score' },
  'vector-llm':       { badge: 'vector-llm-mode',       label: 'Vector+LLM',  short: 'V+L',   tableHeader: 'V+L',   tooltip: 'Vector+LLM score' },
  'hybrid-os':        { badge: 'hybrid-os-mode',        label: 'Hybrid OS',   short: 'H-OS',  tableHeader: 'OS',    tooltip: 'OpenSearch hybrid (BM25 + kNN) score' },
  'hybrid-os-judge':  { badge: 'hybrid-os-judge-mode',  label: 'OS Judge',    short: 'H-OS-J', tableHeader: 'Judge', tooltip: 'Hybrid OS + LLM scorer + LLM-as-judge consensus' },
};

export function modeBadgeClass(mode) {
  return META[mode]?.badge || 'llm-mode';
}

export function modeLabel(mode) {
  return META[mode]?.label || (mode || 'llm').toUpperCase();
}

export function modeShortLabel(mode) {
  return META[mode]?.short || (mode || 'LLM').toUpperCase();
}

export function modeTableHeader(mode) {
  return META[mode]?.tableHeader || 'Sem';
}

export function modeTableTooltip(mode) {
  return META[mode]?.tooltip || 'LLM semantic score';
}
